import { render, staticRenderFns } from "./ChartTranslator.vue?vue&type=template&id=9b71336a&"
import script from "./ChartTranslator.vue?vue&type=script&lang=js&"
export * from "./ChartTranslator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports